import React, { Component } from "react"
import { connect } from "react-redux"
import styled, { injectGlobal, css } from 'styled-components'
import Link from "gatsby-link"
import { rgba } from 'polished';
import Form from 'react-dynamic-form'

import { MetaTags, Input } from '../components'
import { postData } from '../services/api'
import { NEWSLETTER_WEBHOOK_URL } from '../constants'

import { fetchSettings, getSettings } from '../store/settings'

import { warmBrown } from '../styles/themes'
import { container, button, bgIcon, bgImage, innerContainer, hoverState } from '../styles/global'
import { heading2, paragraph, caption } from '../styles/type'
import { media } from '../styles/utils'
import { grey } from '../styles/colors'
import { required, email } from '../utils/validators'


const ArrowRightIcon = () => (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M5 12H19M13 6L19 12L13 18" stroke="#4D402E" strokeLinecap="square" strokeLinejoin="round"/>
    </svg>
)

const ChevronDownIcon = () => (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M6 9L12 15L18 9" stroke="#595850" strokeLinecap="square" strokeLinejoin="round"/>
    </svg>
)


class EnquiryDropdown extends Component {
    state = { open: false }

    componentDidMount() {
        document.addEventListener('mousedown', this.handleClickOutside)
    }

    componentWillUnmount() {
        document.removeEventListener('mousedown', this.handleClickOutside)
    }

    handleClickOutside = (e) => {
        if (this.wrapperEl && !this.wrapperEl.contains(e.target)) {
            this.setState({ open: false })
        }
    }

    toggle = () => {
        this.setState({ open: !this.state.open })
    }

    select = (val) => {
        const { onChange } = this.props
        onChange && onChange(val)
        this.setState({ open: false })
    }

    render() {
        const { value, options, placeholder } = this.props
        const { open } = this.state
        const current = options.find((o) => o.value === value)

        return (
            <DropdownWrapper innerRef={(r) => (this.wrapperEl = r)}>
                <DropdownTrigger onClick={this.toggle} hasValue={!!current}>
                    <DropdownLabel>{current ? current.label : placeholder}</DropdownLabel>
                    <DropdownChevron open={open}>
                        <ChevronDownIcon />
                    </DropdownChevron>
                </DropdownTrigger>

                {open && (
                    <DropdownPanel>
                        {options.map((opt) => (
                            <DropdownOption
                                key={opt.value}
                                selected={value === opt.value}
                                onClick={() => this.select(opt.value)}
                            >
                                {opt.label}
                            </DropdownOption>
                        ))}
                    </DropdownPanel>
                )}
            </DropdownWrapper>
        )
    }
}


class Contact extends Component {

    constructor(props) {
        super(props);
		this.contactForm = React.createRef()
		this.newsletterForm = React.createRef()
    }

	state = {
		acf: {},
        formComplete: false,
        formError: null,
        newsletterComplete: false,
        newsletterError: null,
        selectedEnquiryType: null,
        messageValue: '',
	}

	componentWillMount = () => {
        const data = this.props.data.wordpressContact
        this.props.fetchSettings()
		this.setState({
			acf: JSON.parse(data.acf_json)
		})
    }

    onFieldChange = (field) => {
        if (field.name === 'enquiry_type') {
            this.setState({ selectedEnquiryType: field.value })
        }
        if (field.name === 'message') {
            this.setState({ messageValue: field.value || '' })
        }
    }

    handleSubmit = (fields, resetForm) => {
        const self = this;

		const data = {
			first_name: fields['firstname'].value,
			last_name: fields['lastname'].value,
            email: fields['email'].value,
            phone: fields['phone'] ? fields['phone'].value : '',
            enquiry_type: fields['enquiry_type'] ? fields['enquiry_type'].value : '',
            message: fields['message'].value,
		}

     	postData('/cr/contact-form', data)
            .then(response => {
                if (response.error) {
                    self.setState({ formError: response.message })
                    resetForm()
                } else {
                    self.setState({
                        formComplete: true,
                        selectedEnquiryType: null,
                        messageValue: '',
                    })
                    resetForm()
                }
            })
    }

    handleNewsletterSubmit = (fields, resetForm) => {
        const emailValue = fields['email'].value

        // Form-encoded body avoids a CORS preflight against Zapier's catch hook.
        const body = new URLSearchParams()
        body.append('email', emailValue)
        body.append('source', 'contact_page')

        fetch(NEWSLETTER_WEBHOOK_URL, {
            method: 'POST',
            body,
        }).then((r) => {
            if (r.ok) {
                this.setState({ newsletterComplete: true, newsletterError: null })
                resetForm()
            } else {
                this.setState({ newsletterError: 'Something went wrong. Please try again.' })
            }
        }).catch(() => {
            this.setState({ newsletterError: 'Something went wrong. Please try again.' })
        })
    }

    renderNewsletterBand = () => {
        const { newsletterComplete, newsletterError } = this.state;

        const newsletterFields = {
            fields: [
                {
                    type: 'text',
                    name: 'email',
                    label: 'Email Address',
                    validator: email,
                    errorMessage: 'Please enter a valid email address',
                },
            ]
        }

        return (
            <NewsletterBand>
                <NewsletterInner>
                    <NewsletterHeading>Stay Connected</NewsletterHeading>
                    <NewsletterRight>
                        <NewsletterCopy>
                            Subscribe to receive occasional updates from the studio, including recent projects, publications and news from Paul Conrad Architects.
                        </NewsletterCopy>

                        {newsletterComplete ? (
                            <NewsletterThanks>Thanks — you're subscribed.</NewsletterThanks>
                        ) : (
                            <NewsletterFormRow>
                                <NewsletterFormInputWrap>
                                    <Form
                                        ref={this.newsletterForm}
                                        data={newsletterFields}
                                        styles={newsletterFormStyles}
                                        renderInput={<Input />}
                                        renderSubmit={false}
                                        onSubmit={this.handleNewsletterSubmit}
                                        moveToInvalidField={false}
                                    />
                                </NewsletterFormInputWrap>
                                <NewsletterArrow
                                    onClick={() => {
                                        this.newsletterForm.current && this.newsletterForm.current.handleSubmit()
                                    }}
                                    aria-label="Subscribe"
                                >
                                    <ArrowRightIcon />
                                </NewsletterArrow>
                            </NewsletterFormRow>
                        )}

                        {newsletterError && (
                            <NewsletterError>{newsletterError}</NewsletterError>
                        )}
                    </NewsletterRight>
                </NewsletterInner>
            </NewsletterBand>
        )
    }

    renderContactInfo = () => {
        const { acf } = this.state;

        return (
            <ContactColumn>
                <ColumnLabel>Contact</ColumnLabel>

                <InfoBlock>
                    Paul Conrad Architects<br/>
                    3–5 Jessie St, Cremorne<br/>
                    Victoria 3121 Australia
                </InfoBlock>

                <InfoBlock>
                    Nominated Architect - Paul Conrad<br/>
                    NSW Architect Registration Number DR 15783<br/>
                    VIC Architect Registration Number 51125<br/>
                    WA Architect Registration Number 3894
                </InfoBlock>

                <InfoBlock>
                    <div><InfoLabel>Email:</InfoLabel> <a href="mailto:studio@paulconradarchitects.com">studio@paulconradarchitects.com</a></div>
                    <div><InfoLabel>Telephone:</InfoLabel> +61 (3) 9421 6103</div>
                    <div><InfoLabel>Instagram:</InfoLabel> <a href="https://instagram.com/paulconradarchitects" target="_blank" rel="noopener noreferrer">@paulconradarchitects</a></div>
                </InfoBlock>

                <CareersBlock>
                    At Paul Conrad Architects we are always looking for creative and passionate architects. If you would like to enquire about joining our team please email your CV to <a href="mailto:careers@paulconradarchitects.com">careers@paulconradarchitects.com</a> (maximum 8MB file size)
                </CareersBlock>

                <PrivacyLink to="/privacy-policy">Privacy Policy</PrivacyLink>
            </ContactColumn>
        )
    }

    renderContactForm = () => {
		const { formError, formComplete, selectedEnquiryType, messageValue } = this.state;

        const enquiryOptions = [
            { label: 'New Project', value: 'new_project' },
            { label: 'Media', value: 'media' },
            { label: 'Careers', value: 'careers' },
            { label: 'Other', value: 'other' },
        ]

        const showNewProjectHint = selectedEnquiryType === 'new_project' && !messageValue

		const contactFormFields = {
			fields: [
				{
					type: 'text',
					name: 'firstname',
					label: 'First Name',
					validator: required,
					errorMessage: 'This field is required',
				},
                {
					type: 'text',
					name: 'lastname',
					label: 'Last Name',
					validator: required,
					errorMessage: 'This field is required',
				},
                {
                    type: 'text',
                    name: 'email',
                    label: 'Email Address',
                    validator: email,
                    errorMessage: 'Please enter a valid email address',
                },
                {
                    type: 'text',
                    name: 'phone',
                    label: 'Phone Number',
                },
                {
                    type: 'select',
                    name: 'enquiry_type',
                    label: 'Enquiry Type',
                    validator: required,
                    errorMessage: 'Please select an enquiry type',
                    component: ({ value, onChangeValue, validator }) => (
                        <EnquiryDropdown
                            value={value}
                            options={enquiryOptions}
                            placeholder="Enquiry Type"
                            onChange={(v) => onChangeValue(v, validator)}
                        />
                    ),
                },
                {
                    type: 'textarea',
                    name: 'message',
                    label: 'Message',
                    placeholder: showNewProjectHint
                        ? 'Please include location, timeline, budget and scope.'
                        : 'Message',
                    validator: required,
                    errorMessage: 'This field is required',
                },
			]
		}

		return (
            <FormColumn>
                {formComplete && (
					<ThankYou
						dangerouslySetInnerHTML={{__html: `
							Thank you, your message has been received.<br/><br/>
							We'll be in touch soon.
						`}}
					/>
				)}

                {!formComplete && (
                    <FormContent>
                        <Form
                            ref={this.contactForm}
                            data={contactFormFields}
                            styles={formStyles}
                            renderInput={<Input />}
                            renderSubmit={false}
                            onSubmit={this.handleSubmit}
                            onFieldChange={this.onFieldChange}
                            moveToInvalidField={false}
                        />

                        <FormFooter>
                            <Button
                                onClick={() => {
                                    this.contactForm.current && this.contactForm.current.handleSubmit()
                                }}
                            >
                                Submit
                            </Button>

                            {formError && (
                                <Error>{formError}</Error>
                            )}
                        </FormFooter>
                    </FormContent>
                )}
            </FormColumn>
		)
	}


  	render() {
        const { acf } = this.state;
        const splashActive = this.props.settings.splashActive;

        return (
            <Wrapper
                active={splashActive == false}
            >
                <MetaTags
                    title={`Paul Conrad Architects — Contact`}
                />

                {acf.hero_image && acf.hero_image.sizes && (
                    <HeroImage
                        image={acf.hero_image.sizes.full_width || acf.hero_image.sizes.large}
                    />
                )}

                <ContactSection>
                    {this.renderContactInfo()}
                    {this.renderContactForm()}
                </ContactSection>

                {this.renderNewsletterBand()}
            </Wrapper>
        )
  	}
}



const Wrapper = styled.div`
	display: flex;
	flex-direction: column;
	align-items: center;
	width: 100%;
	z-index: 2;
    padding-top: 10rem;
    padding-bottom: 15rem;
    transition: all 0.75s ease;
	transition-delay: 0.4s;
	will-change: transform;
    transform: translateY(100px);
	opacity: 0;

    /* Contact page opts out of the site-wide "indent subsequent paragraphs" rule */
    * {
        text-indent: 0 !important;
    }

    ${media.phone`
        padding-top: 0;
    `}

	${props => {
		if (props.active) return css`
			transform: translateY(0);
			opacity: 1;
		`
	}}
`


// Hero image (top of page, above the enquiry form)

/* Full-bleed, matching the project template's hero rather than the 1200px
   content column below it. */
const HeroImage = styled.div`
    width: 100%;
    height: 600px;
    margin-bottom: 10rem;
    background-image: url(${props => props.image});
    ${bgImage}

    ${media.laptop`
        height: 500px;
    `}

    ${media.tablet`
        height: 400px;
        margin-bottom: 8rem;
    `}

    ${media.phone`
        height: 235px;
        margin-bottom: 5rem;
    `}
`


// Newsletter band (now below the enquiry form)

const NewsletterBand = styled.div`
    width: 100%;
    max-width: 1200px;
    background: transparent;
    box-sizing: border-box;
    padding: 0 2.5rem;
    margin-top: 8rem;

    ${media.phone`
        margin-top: 4rem;
        padding: 0;
    `}
`

const NewsletterInner = styled.div`
    display: flex;
    flex-direction: row;
    padding: 6rem 4rem;
    box-sizing: border-box;

    ${media.tablet`
        flex-direction: column;
        padding: 4rem 3rem;
    `}

    ${media.phone`
        padding: 4rem 40px;
    `}
`

const NewsletterHeading = styled.div`
    flex: 1 1 40%;
    font-family: 'Scto';
    font-weight: 300;
    font-size: 28px;
    line-height: 34px;
    color: ${grey};

    ${media.laptop`
        font-size: 22px;
        line-height: 28px;
    `}

    ${media.tablet`
        margin-bottom: 3rem;
    `}
`

const NewsletterRight = styled.div`
    flex: 1 1 60%;
    display: flex;
    flex-direction: column;
`

const NewsletterCopy = styled.div`
    ${paragraph};
    color: ${grey};
    margin-bottom: 3rem;
`

const NewsletterFormRow = styled.div`
    display: flex;
    align-items: center;
    position: relative;
    border-bottom: 1px solid ${rgba('#595850', 0.4)};

    /* Kill the inner field's built-in underline & spacing so only the row's
       border-bottom is visible and the arrow sits flush at the right edge. */
    .dynamic-field { margin-bottom: 0 !important; }
    .field-wrapper {
        border-bottom: 0 !important;
        margin-bottom: 0 !important;
    }
`

const NewsletterFormInputWrap = styled.div`
    flex: 1;
    min-width: 0;
`

const NewsletterArrow = styled.button`
    background: transparent;
    border: 0;
    padding: 0;
    margin-left: 16px;
    display: flex;
    align-items: center;
    cursor: pointer;

    svg { display: block; }
    &:hover { opacity: 0.7; }
`

const NewsletterThanks = styled.div`
    ${paragraph};
    color: ${grey};
    padding: 12px 0;
`

const NewsletterError = styled.div`
    ${caption};
    color: #F03232;
    margin-top: 8px;

    a { color: #F03232; text-decoration: underline; }
`

const newsletterFormStyles = css`
    .dynamic-field {
        margin-bottom: 0;
        .field-wrapper {
            border-bottom: 0;
            margin-bottom: 0;
        }
    }
`


// Contact section (2-col)

const ContactSection = styled.div`
    display: flex;
    flex-direction: row;
    width: 100%;
    max-width: 1200px;
    box-sizing: border-box;
    padding: 0 2.5rem;

    ${media.phone`
        flex-direction: column;
        padding: 0 40px;
    `}
`

const ContactColumn = styled.div`
    flex: 1 1 50%;
    padding-right: 4rem;
    box-sizing: border-box;

    ${media.phone`
        padding-right: 0;
        margin-bottom: 5rem;
    `}
`

const FormColumn = styled.div`
    flex: 1 1 50%;
    box-sizing: border-box;
`

const ColumnLabel = styled.div`
    ${paragraph};
    color: ${grey};
    margin-bottom: 4rem;
`

const InfoBlock = styled.div`
    ${paragraph};
    color: ${grey};
    margin-bottom: 3rem;

    a { color: ${grey}; ${hoverState}; }
`

const InfoLabel = styled.span`
    color: ${rgba('#595850', 0.55)};
`

const CareersBlock = styled.div`
    ${caption};
    color: ${rgba('#595850', 0.55)};
    max-width: 340px;
    margin-bottom: 4rem;

    a { color: ${rgba('#595850', 0.7)}; text-decoration: underline; }
`

const PrivacyLink = styled(Link)`
    ${caption};
    color: ${rgba('#595850', 0.55)};
    ${hoverState};
`


// Form column pieces

const FormContent = styled.div``

const FormFooter = styled.div`
    margin-top: 2rem;
`

const Button = styled.div`
    display: inline-block;
    width: 100px;
    font-size: 16px;
    color: #595850;
    background-color: #F5F4F2;
    padding: 12px 0;
    text-align: center;
    &:hover { cursor: pointer; }

    ${media.phone`
        font-size: 14px;
        line-height: 18px;
    `}
`

const Error = styled.div`
    ${caption};
    color: #F03232;
    margin-top: 12px;
`

const ThankYou = styled.div`
    ${paragraph};
    color: ${grey};

    ${media.phone`
        padding: 0 40px;
    `}
`

// Custom Enquiry Type dropdown

const DropdownWrapper = styled.div`
    position: relative;
    width: 100%;
`

const DropdownTrigger = styled.div`
    display: flex;
    align-items: center;
    justify-content: space-between;
    height: 52px;
    cursor: pointer;
    font-family: 'Scto';
    font-weight: 300;
    font-size: 18px;
    line-height: 24px;
    color: ${props => props.hasValue ? '#595850' : '#595850'};

    ${media.phone`
        font-size: 14px;
        line-height: 18px;
    `}
`

const DropdownLabel = styled.div`
    flex: 1;
`

const DropdownChevron = styled.div`
    display: flex;
    align-items: center;
    transition: transform 0.15s ease;
    transform: ${props => props.open ? 'rotate(180deg)' : 'rotate(0)'};

    svg { display: block; }
`

const DropdownPanel = styled.div`
    position: absolute;
    top: calc(100% + 8px);
    left: 0;
    right: 0;
    z-index: 20;
    background: #FFFFFF;
    border: 1px solid ${rgba('#595850', 0.15)};
    box-shadow: 0 8px 24px ${rgba('#000000', 0.06)};
    padding: 6px 0;
`

const DropdownOption = styled.div`
    padding: 14px 20px;
    font-family: 'Scto';
    font-weight: 300;
    font-size: 18px;
    line-height: 24px;
    color: #595850;
    cursor: pointer;
    transition: background 0.1s ease;

    &:hover {
        background: #F5F4F2;
    }

    ${props => props.selected && css`
        background: #F5F4F2;
    `}

    ${media.phone`
        font-size: 14px;
        line-height: 18px;
        padding: 12px 16px;
    `}
`


const formStyles = css`
	flex-direction: row;
    flex-wrap: wrap;
	align-items: flex-start;
    display: flex;

	.dynamic-field {
		margin-bottom: 14px;
        flex: 1 0 100%;

        ${media.phone`
            margin-bottom: 5px;
        `}

        &.firstname, &.lastname {
            flex: 1 0 50%;
            ${media.phone`
                flex: 1 0 100%;
            `}
        }

        &.firstname {
            .field-wrapper {
                margin-right: 10px;
            }
        }
	}
`


const mapDispatchToProps = dispatch => ({
    fetchSettings() {
        dispatch(fetchSettings())
    },
})

const mapStateToProps = (state, props) => ({
    settings: state.settings.settings
})

export default connect(mapStateToProps, mapDispatchToProps)(Contact);


export const pageQuery = graphql`
	query Contact {
		wordpressContact {
			acf_json
		}
	}
`



// WEBPACK FOOTER //
// ./src/pages/Contact.jsx